function handleAddToCart(el) {
  let selectedProducts = [];
  let qty = 1; 
  var variantId = $(el).data('variant-id'); 
  var isHeatSensitive = $(el).data('is-heat-sensitive');

  let data = {
    id: variantId,
    quantity: qty,
    properties: {
      "_heatSensitive": `${isHeatSensitive}`
    }
  };

  try {
    const gGridForm = el.closest('.gridProductPreOrderForm')
    if(gGridForm){
        const gPreorderProperty = gGridForm.querySelector('.gPreorderProperty')
        const gPreorderLocale = gGridForm.querySelector('.gPreorderLocale')
        const gPreorderNote = gGridForm.querySelector('.gPreorderProperty[name="properties[Note]"]')
        const gPreorderSellingPlan = gGridForm.querySelector('input[name="selling_plan"]:checked') ??  gGridForm.querySelector('input[name="selling_plan"]')

        if(gPreorderProperty && gPreorderLocale){
            data['properties'] = {
                ...data['properties'],
                _is_preorder: gPreorderProperty.value,
                _preorder_locale: gPreorderLocale.value,
                note: gPreorderNote.value ?? "Preorder item"
            }
            if(gPreorderSellingPlan)
              data['selling_plan'] = gPreorderSellingPlan.value
        }
    }
  } catch (error) {
    
  }
  
  selectedProducts = [data]

  let formData = {
    'items': selectedProducts
  }

  if (selectedProducts.length > 0) {
    $(el).prop('disabled', true);
    $(el).addClass('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(res => res.json())
    .then(data => {

      $(el).removeClass('loading');
      $(el).addClass('has-success');
      
      initCartEvent();
      initCartPopdown(data.items[0]);

      setTimeout(() => {
        $(el).removeClass('has-success');
        $(el).prop('disabled', false);
      }, 3000);
    })
    .catch(err => {
      console.error(err);
    })
  }
}

function initCartEvent() {
  document.documentElement.dispatchEvent(new CustomEvent('theme:cart:init', {
    bubbles: true
  }));
}

function initCartPopdown(variant) {
  document.documentElement.dispatchEvent(
    new CustomEvent('theme:cart:popdown', {
      detail: {
        variant: variant,
      },
      bubbles: true,
    })
  );
}

